var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightUturn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206,
    height: 164,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C23.1 0 46.2 0 70 0 C70 1.65 70 3.3 70 5 C73.3 5 76.6 5 80 5 C80 6.65 80 8.3 80 10 C81.65 10 83.3 10 85 10 C85 11.65 85 13.3 85 15 C86.65 15 88.3 15 90 15 C90 16.65 90 18.3 90 20 C91.65 20 93.3 20 95 20 C95 33.2 95 46.4 95 60 C93.35 60 91.7 60 90 60 C90 61.65 90 63.3 90 65 C88.35 65 86.7 65 85 65 C85 66.65 85 68.3 85 70 C83.35 70 81.7 70 80 70 C80 71.65 80 73.3 80 75 C78.35 75 76.7 75 75 75 C75 76.65 75 78.3 75 80 C71.7 80 68.4 80 65 80 C65 81.65 65 83.3 65 85 C50.15 85 35.3 85 20 85 C20 86.65 20 88.3 20 90 C21.65 90 23.3 90 25 90 C25 91.65 25 93.3 25 95 C26.65 95 28.3 95 30 95 C30 96.65 30 98.3 30 100 C28.35 100 26.7 100 25 100 C25 101.65 25 103.3 25 105 C23.35 105 21.7 105 20 105 C20 106.65 20 108.3 20 110 C16.7 110 13.4 110 10 110 C10 108.35 10 106.7 10 105 C8.35 105 6.7 105 5 105 C5 103.35 5 101.7 5 100 C3.35 100 1.7 100 0 100 C0 98.35 0 96.7 0 95 C-1.65 95 -3.3 95 -5 95 C-5 93.35 -5 91.7 -5 90 C-6.65 90 -8.3 90 -10 90 C-10 88.35 -10 86.7 -10 85 C-11.65 85 -13.3 85 -15 85 C-15 83.35 -15 81.7 -15 80 C-16.65 80 -18.3 80 -20 80 C-20 75.05 -20 70.1 -20 65 C-18.35 65 -16.7 65 -15 65 C-15 63.35 -15 61.7 -15 60 C-13.35 60 -11.7 60 -10 60 C-10 58.35 -10 56.7 -10 55 C-8.35 55 -6.7 55 -5 55 C-5 53.35 -5 51.7 -5 50 C-3.35 50 -1.7 50 0 50 C0 48.35 0 46.7 0 45 C3.3 45 6.6 45 10 45 C10 41.7 10 38.4 10 35 C13.3 35 16.6 35 20 35 C20 36.65 20 38.3 20 40 C21.65 40 23.3 40 25 40 C25 44.95 25 49.9 25 55 C23.35 55 21.7 55 20 55 C20 56.65 20 58.3 20 60 C18.35 60 16.7 60 15 60 C15 61.65 15 63.3 15 65 C31.5 65 48 65 65 65 C65 63.35 65 61.7 65 60 C66.65 60 68.3 60 70 60 C70 58.35 70 56.7 70 55 C71.65 55 73.3 55 75 55 C75 45.1 75 35.2 75 25 C71.7 25 68.4 25 65 25 C65 23.35 65 21.7 65 20 C43.55 20 22.1 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EC6358",
    transform: "translate(65,33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C19.8 0 39.6 0 60 0 C60 1.65 60 3.3 60 5 C40.2 5 20.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F8D7D4",
    transform: "translate(65,28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.5 0 33 0 50 0 C50 1.65 50 3.3 50 5 C35.15 5 20.3 5 5 5 C5 6.65 5 8.3 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#F3ADA9",
    transform: "translate(80,113)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C18.15 0 36.3 0 55 0 C55 1.65 55 3.3 55 5 C36.85 5 18.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F19C95",
    transform: "translate(65,48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C16.5 0 33 0 50 0 C50 1.65 50 3.3 50 5 C33.5 5 17 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F6C5C2",
    transform: "translate(80,93)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C8.35 5 6.7 5 5 5 C5 6.65 5 8.3 5 10 C3.35 10 1.7 10 0 10 C0 11.65 0 13.3 0 15 C-1.65 15 -3.3 15 -5 15 C-5 16.65 -5 18.3 -5 20 C-6.65 20 -8.3 20 -10 20 C-10 21.65 -10 23.3 -10 25 C-13.3 25 -16.6 25 -20 25 C-20 23.35 -20 21.7 -20 20 C-18.35 20 -16.7 20 -15 20 C-15 18.35 -15 16.7 -15 15 C-13.35 15 -11.7 15 -10 15 C-10 13.35 -10 11.7 -10 10 C-8.35 10 -6.7 10 -5 10 C-5 8.35 -5 6.7 -5 5 C-3.35 5 -1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6D62",
    transform: "translate(65,78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F4B5B0",
    transform: "translate(160,63)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 6.6 5 13.2 5 20 C3.35 20 1.7 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F5C0BC",
    transform: "translate(140,63)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 1.65 20 3.3 20 5 C13.4 5 6.8 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6C62",
    transform: "translate(115,33)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C6.65 5 8.3 5 10 5 C10 6.65 10 8.3 10 10 C6.7 10 3.4 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#ED7066",
    transform: "translate(85,123)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 1.65 15 3.3 15 5 C10.05 5 5.1 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B8B5",
    transform: "translate(115,113)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 1.65 15 3.3 15 5 C10.05 5 5.1 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6E64",
    transform: "translate(125,108)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 4.95 5 9.9 5 15 C3.35 15 1.7 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#ED685D",
    transform: "translate(155,78)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 4.95 5 9.9 5 15 C3.35 15 1.7 15 0 15 C0 10.05 0 5.1 0 0 Z ",
    fill: "#FAE0DF",
    transform: "translate(60,33)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE766D",
    transform: "translate(75,138)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 3.3 5 6.6 5 10 C3.35 10 1.7 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#ED6E64",
    transform: "translate(75,113)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0968F",
    transform: "translate(120,93)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0928B",
    transform: "translate(75,68)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED7369",
    transform: "translate(130,53)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C10 1.65 10 3.3 10 5 C6.7 5 3.4 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE786F",
    transform: "translate(120,48)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FCEEEE",
    transform: "translate(80,143)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F19891",
    transform: "translate(75,138)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F19891",
    transform: "translate(70,133)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B3AD",
    transform: "translate(90,128)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F09791",
    transform: "translate(65,128)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F3ADA9",
    transform: "translate(85,123)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6E64",
    transform: "translate(80,123)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F09690",
    transform: "translate(60,123)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0968F",
    transform: "translate(55,118)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F8D2CF",
    transform: "translate(125,113)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EF857E",
    transform: "translate(75,113)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0958E",
    transform: "translate(50,113)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F19891",
    transform: "translate(135,108)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0958E",
    transform: "translate(45,108)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FBE9E8",
    transform: "translate(145,103)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6E64",
    transform: "translate(140,103)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAE1E0",
    transform: "translate(150,98)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6D63",
    transform: "translate(145,98)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B0",
    transform: "translate(45,98)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FBE8E7",
    transform: "translate(155,93)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE756C",
    transform: "translate(150,93)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6E63",
    transform: "translate(130,93)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F2A9A4",
    transform: "translate(120,93)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE7F76",
    transform: "translate(75,93)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B0",
    transform: "translate(50,93)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EF8981",
    transform: "translate(155,88)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE786F",
    transform: "translate(135,88)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F9DBD8",
    transform: "translate(130,88)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F08F88",
    transform: "translate(80,88)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B1",
    transform: "translate(55,88)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FCECEB",
    transform: "translate(160,83)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6B61",
    transform: "translate(140,83)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F08E87",
    transform: "translate(85,83)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B1",
    transform: "translate(60,83)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F6C4C0",
    transform: "translate(160,78)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F2A49F",
    transform: "translate(140,78)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B1",
    transform: "translate(90,78)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B5B1",
    transform: "translate(65,78)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FDF3F2",
    transform: "translate(90,73)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED746B",
    transform: "translate(85,73)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6D62",
    transform: "translate(75,73)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B6B2",
    transform: "translate(70,73)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F3ABA7",
    transform: "translate(75,68)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F7C9C7",
    transform: "translate(160,63)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F0968F",
    transform: "translate(140,63)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FDF3F2",
    transform: "translate(80,63)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#ED6F65",
    transform: "translate(140,58)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAE1E0",
    transform: "translate(135,58)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F19891",
    transform: "translate(155,53)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F3AFAA",
    transform: "translate(130,53)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE786F",
    transform: "translate(150,48)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F2A6A2",
    transform: "translate(115,48)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F4B3AE",
    transform: "translate(65,48)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EE756C",
    transform: "translate(145,43)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EF857E",
    transform: "translate(140,38)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#F7C9C6",
    transform: "translate(135,33)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EF877F",
    transform: "translate(130,33)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FBE8E7",
    transform: "translate(60,33)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAE3E2",
    transform: "translate(120,28)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 1.65 5 3.3 5 5 C3.35 5 1.7 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#FAE3E2",
    transform: "translate(65,28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightUturn);
export default __webpack_public_path__ + "static/media/right-uturn.cb948ea76aaa6c8374ee81ffdb831dc3.svg";
export { ForwardRef as ReactComponent };